import React, { useRef } from 'react';
import { Workspace } from './types';

interface WorkspaceTabBarProps {
  workspaces: Workspace[];
  activeWorkspaceId: string;
  onSelectWorkspace: (id: string) => void;
  onAddWorkspace: () => void;
  onOpenContextMenu: (workspace: Workspace, anchorEl: HTMLElement) => void;
}

const WorkspaceTabBar: React.FC<WorkspaceTabBarProps> = ({
  workspaces,
  activeWorkspaceId,
  onSelectWorkspace,
  onAddWorkspace,
  onOpenContextMenu,
}) => {
  return (
    <div className="workspace-tab-bar">
      {workspaces.map((ws) => (
        <button
          key={ws.id}
          className={`workspace-tab ${ws.id === activeWorkspaceId ? 'active' : ''}`}
          onClick={() => onSelectWorkspace(ws.id)}
          onContextMenu={(e) => {
            if (ws.isAllApps) return;
            e.preventDefault();
            onOpenContextMenu(ws, e.currentTarget);
          }}
        >
          <span className="workspace-tab-icon">{ws.icon}</span>
          <span className="workspace-tab-name">{ws.name}</span>
          {!ws.isAllApps && (
            <span
              className="workspace-tab-settings"
              onClick={(e) => {
                e.stopPropagation();
                onOpenContextMenu(ws, e.currentTarget as HTMLElement);
              }}
            >
              ...
            </span>
          )}
        </button>
      ))}
      <button
        className="workspace-add-btn"
        onClick={onAddWorkspace}
        title="Create new workspace"
      >
        +
      </button>
    </div>
  );
};

export default WorkspaceTabBar;
